namespace Matrix {
    export interface ExcelImportRequest extends Serenity.ServiceRequest {
        FileName?: string;
    }
}
